import { assertUnreachable } from "../../helpers/utilities.js";
import { InterviewSectionType } from "./types.js";
function computeInterviewSectionOptionsForJobType(jobType, definitions) {
  const jobTypeQuestionsSection = jobType?.questions.length ? {
    source: {
      type: "job_type",
      id: jobType.id
    },
    settings: {
      type: "questions"
    }
  } : void 0;
  const implicitSections = jobTypeQuestionsSection ? [jobTypeQuestionsSection] : [];
  const explicitSections = definitions.map(
    (section) => ({
      source: {
        type: "interview_section_definition",
        id: section.id
      },
      settings: section.settings
    })
  );
  return [...implicitSections, ...explicitSections];
}
const interviewSectionTypeDisplayNames = {
  [InterviewSectionType.Questions]: "Screening interview",
  [InterviewSectionType.RolePlay]: "Role play",
  [InterviewSectionType.KnowledgeTest]: "Knowledge test",
  [InterviewSectionType.ChatQuiz]: "Chat quiz"
};
function getInterviewSectionTopic(settings) {
  switch (settings?.type) {
    case InterviewSectionType.Questions:
      return void 0;
    case InterviewSectionType.KnowledgeTest:
    case InterviewSectionType.RolePlay:
      return settings.title;
    case InterviewSectionType.ChatQuiz:
      return settings.topic;
    case void 0:
      return void 0;
    default:
      return assertUnreachable(settings, () => void 0);
  }
}
function getInterviewSectionTitle(settings, fallback = "Unknown section") {
  const topic = getInterviewSectionTopic(settings);
  if (topic) {
    return topic;
  }
  const displayName = settings ? interviewSectionTypeDisplayNames[settings.type] : void 0;
  if (displayName) {
    return displayName;
  }
  return fallback;
}
function buildSectionDefinitionsById(sectionDefinitions) {
  const sectionDefinitionsById = /* @__PURE__ */ new Map();
  for (const sectionDefinition of sectionDefinitions) {
    sectionDefinitionsById.set(sectionDefinition.id, sectionDefinition);
  }
  return sectionDefinitionsById;
}
export {
  buildSectionDefinitionsById,
  computeInterviewSectionOptionsForJobType,
  getInterviewSectionTitle,
  getInterviewSectionTopic,
  interviewSectionTypeDisplayNames
};
//# sourceMappingURL=definition.js.map
